import { useDispatch, useSelector } from 'react-redux';
import useTranslation from '../../../../../hooks/useTranslations';
import { addObjectIdToFavoriteList, openFavoritesFormModal, removeObjectIdFromFavoriteList, selectFavoriteLists } from '../../../../../redux/modules/favoritesSlice';
import { ArrowIcon, StarIcon } from '../../../../misc/icons/Icons';
import PopupWrapper, { PopoverItem } from '../../../layouts/partials/PopupWrapper';

const FavListsPopover = ({ isObjectRow = false, isSliderTile = false, object }) => {
	const favoriteLists = useSelector((state) => selectFavoriteLists(state));
	const dispatch = useDispatch();

	let skidding = 0;

	if (!isObjectRow && favoriteLists?.length) {
		if (!isSliderTile) {
			skidding = -43;
		} else if (favoriteLists?.length === 1) {
			skidding = -52;
		} else {
			skidding = -95;
		}
	}

	const selectedFavList = ({ favListId, isActive }) => {
		if (isActive) {
			dispatch(removeObjectIdFromFavoriteList({ objectId: object.id, favoriteListId: favListId }));
		} else {
			dispatch(addObjectIdToFavoriteList({ objectId: object.id, favoriteListId: favListId }));
		}
	};

	const favListItems = favoriteLists?.map((favList) => (<PopoverItem key={favList.id} id={favList.id} title={favList.title} isActive={favList.objectIds.includes(object.id)} callback={({ id, isActive }) => selectedFavList({ favListId: id, isActive })} />));

	return (
		<PopupWrapper
			button={(
				<div className={`${isObjectRow ? 'can-hover:hover:shadow-button focus-visible:shadow-button' : 'can-hover:hover:text-yellow-600 focus-visible:text-yellow-600 can-hover:sm:hover:shadow-button sm:focus-visible:shadow-button'} p-2 transition duration-150 ease-in-out rounded-md text-oly-yellow-default`}>
					<StarIcon className={isObjectRow ? 'w-6 h-6 xl:w-8 xl:h-8' : 'w-5 h-5 sm:w-7 sm:h-7'} />
				</div>
			)}
			items={favListItems}
			width={`${isObjectRow ? 'w-56' : ''} sm:w-64`}
			maxHeight="max-h-54 sm:max-h-68"
			placement="left"
			skidding={skidding}
			distance={16}
		>
			<NewFavListButton object={object} />
		</PopupWrapper>
	);
};

const NewFavListButton = ({ object }) => {
	const t = useTranslation();
	const dispatch = useDispatch();

	const openModal = () => {
		dispatch(openFavoritesFormModal({ object }));
	};

	return (
		<button
			type="button"
			onClick={() => openModal()}
			className="flex items-center justify-between w-full p-2 text-left sm:p-3 can-hover:hover:bg-oly-gray-lightestAlpha45 focus-visible:bg-oly-gray-lightestAlpha45 focus:outline-none"
			aria-labelledby="new-favorite-list"
		>
			<span className="leading-4 sm:leading-5 text-[0.75rem] sm:text-[0.9375rem] font-semibold text-oly-gray-darkest mr-2">
				{t('webapp_favs_new_temp')}
			</span>
			<ArrowIcon className="flex-shrink-0 w-4 h-4 transform -rotate-90 sm:w-5 sm:h-5 text-oly-gray-default" />
		</button>
	);
};

export default FavListsPopover;
